export const CLUSTERS = {
  INFORMATION_SECURITY_MANAGEMENT_SYSTEM: 'information-security-management-system' as const,
  PEOPLE: 'people' as const,
  PHYSICAL_SECURITY: 'physical-security' as const,
  ASSET_MANAGEMENT: 'asset-management' as const,
  DATA_PROTECTION: 'data-protection' as const,
  IDENTITY_ACCESS_MANAGEMENT: 'identity-&-access-management' as const,
  NETWORKING_SECURITY: 'networking-security' as const,
  OPERATIONS_SECURITY: 'operations-security' as const,
  CONFIGURATION_MANAGEMENT: 'configuration-management' as const,
  SECURE_DEVELOPMENT: 'secure-development' as const,
  CHANGE_MANAGEMENT: 'change-management' as const,
  RISK_MANAGEMENT: 'risk-management' as const,
  INCIDENT_RESPONSE: 'incident-response' as const,
  BUSINESS_CONTINUITY: 'business-continuity' as const,
  SUPPLY_CHAIN: 'supply-chain' as const,
  COMPLIANCE: 'compliance' as const,
  AUDIT_NON_CONFORMITIES: 'audit-&-non-conformities' as const,
  AWARENESS: 'awareness' as const,
  COMMUNICATIONS: 'communications' as const,
  CRYPTOGRAPHY: 'cryptography' as const,
  CUSTOMER_MANAGEMENT: 'customer-management' as const,
  INTEGRATED_MANAGEMENT_SYSTEM: 'integrated-management-system' as const,
  OPERATIONS_MANAGEMENT: 'operations-management' as const,
  QUALITY_MANAGEMENT: 'quality-management' as const,
  SALES_MANAGEMENT: 'sales-management' as const,
  INTERNAL_AUDIT: 'internal-audit' as const,
}
